import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";


import Login from "../screens/login/LoginMain";
// import PasswordRecovery from "../screens/login/LoginPasswordRecovery";
import Events from "../screens/Events"
import AddEditEvent from "../screens/events/AddEditEvent"
import AddEditTicketType from "../screens/events/AddEditTicketType"
import AddEditTicket from "../screens/events/AddEditTicket"
import StatisticsEvent from "../screens/events/StatisticsEvent"
import StatisticsDirectRRPP from "../screens/events/StatisticsDirectRRPP"
import StatisticsReferencedRRPP from "../screens/events/StatisticsReferencedRRPP"
import StatisticsProducer from "../screens/events/StatisticsProducer"
import StatisticsGift from "../screens/events/StatisticsGift"
import StatisticsLoyalty from "../screens/events/StatisticsLoyalty"
// import StatisticsRRPP from "../screens/events/StatisticsRRPP"
import TicketTypes from "../screens/events/TicketTypes"
import Tickets from "../screens/events/Tickets"
import Users from "../screens/Users"
import Places from "../screens/Places"
import Notifications from "../screens/Notifications"
import AddEditNotifications from "../screens/notifications/AddEditNotifications"
import News from "../screens/News"
import AddEditNovelty from "../screens/news/AddEditNovelty"
import Roles from "../screens/Roles"
import AddEditRoles from "../screens/roles/AddEditRoles"
import Statistics from "../screens/statistics/Statistics"
import Home from "../screens/Home"
/*INIT_IMPORT_SCREENS*/

import {

  INDEX_ROUTE,
  LOGIN_ROUTE,
  // PASSWORD_RECOVERY,
  EVENTS_ROUTE,
  EVENTS_ADD_ROUTE,
  EVENTS_EDIT_ROUTE,
  EVENTS_COPY_ROUTE,
  EVENTS_STATISTICS_ROUTE,
  // STATISTICS_RRPP_ROUTE,
  TICKET_TYPES_ROUTE,
  TICKET_TYPE_ADD_ROUTE,
  TICKET_TYPE_EDIT_ROUTE,
  TICKETS_ROUTE,
  TICKET_ADD_ROUTE,
  TICKET_EDIT_ROUTE,
  USERS_ROUTE,
  USERS_EDIT_ROUTE,
  ROLES_ROUTE,
  ROLES_ADD_ROUTE,
  ROLES_EDIT_ROUTE,
  PLACES_ADD_ROUTE,
  PLACES_EDIT_ROUTE,
  PLACES_ROUTE,
  NEWS_ROUTE,
  NEWS_ADD_ROUTE,
  NEWS_EDIT_ROUTE,
  NOTIFICATIONS_ROUTE,
  NOTIFICATIONS_ADD_ROUTE,
  NOTIFICATIONS_EDIT_ROUTE,
  STATISTICS_ROUTE,
  EVENTS_STATISTICS_DIRECT_RRPP_ROUTE,
  EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE,
  EVENTS_STATISTICS_PRODUCER_ROUTE,
  EVENTS_STATISTICS_GIFT_ROUTE,
  EVENTS_STATISTICS_LOYALTY_ROUTE,
  UNAUTHORIZED_ROUTE,
  TAGS_ROUTE,
  TAGS_ADD_ROUTE,
  TAGS_EDIT_ROUTE
  
} from "./RoutesConstants";
import Tags from "../screens/Tags";
import AddEditTag from "../screens/tags/AddEditTag";
import EditUser from "../screens/users/EditUser";

const Routes = () => {
  return (
    <Switch>
      <Route path={LOGIN_ROUTE}>
        <Login/>
      </Route>
      <Route path={TICKET_TYPE_ADD_ROUTE}>
        <AddEditTicketType isEditing={false}/>
      </Route>
      <Route path={TICKET_TYPE_EDIT_ROUTE}>
        <AddEditTicketType isEditing={true}/>
      </Route>
      <Route path={TICKET_TYPES_ROUTE}>
        <TicketTypes/>
      </Route>
      <Route path={TICKET_ADD_ROUTE}>
        <AddEditTicket isEditing={false}/>
      </Route>
      <Route path={TICKET_EDIT_ROUTE}>
        <AddEditTicket isEditing={true}/>
      </Route>
      <Route path={TICKETS_ROUTE}>
        <Tickets/>
      </Route>
      <Route path={EVENTS_ADD_ROUTE}>
        <AddEditEvent isEditing={false}/>
      </Route>
      <Route path={EVENTS_EDIT_ROUTE}>
        <AddEditEvent isEditing={true}/>
      </Route>
      <Route path={EVENTS_COPY_ROUTE}>
        <AddEditEvent isCopy={true}/>
      </Route>
      {/* <Route path={STATISTICS_RRPP_ROUTE}>
        <StatisticsRRPP/>
      </Route> */}
      <Route path={EVENTS_STATISTICS_DIRECT_RRPP_ROUTE}>
        <StatisticsDirectRRPP/>
      </Route>
      <Route path={EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE}>
        <StatisticsReferencedRRPP/>
      </Route>
      <Route path={EVENTS_STATISTICS_PRODUCER_ROUTE}>
        <StatisticsProducer/>
      </Route>
      <Route path={EVENTS_STATISTICS_GIFT_ROUTE}>
        <StatisticsGift/>
      </Route>
      <Route path={EVENTS_STATISTICS_LOYALTY_ROUTE}>
        <StatisticsLoyalty/>
      </Route>
      <Route path={EVENTS_STATISTICS_ROUTE}>
        <StatisticsEvent/>
      </Route>
      <Route path={EVENTS_ROUTE}>
        <Events/>
      </Route>
      <Route path={USERS_EDIT_ROUTE}>
        <EditUser/>
      </Route>
      <Route path={USERS_ROUTE}>
        <Users/>
      </Route>
      <Route path={ROLES_ADD_ROUTE}>
        <AddEditRoles isEditing={false}/>
      </Route>
      <Route path={ROLES_EDIT_ROUTE}>
        <AddEditRoles isEditing={true}/>
      </Route>
      <Route path={ROLES_ROUTE}>
        <Roles/>
      </Route>
      <Route path={PLACES_ROUTE}>
        <Places/>
      </Route>
      <Route path={UNAUTHORIZED_ROUTE}>
        <h1>Desautorizado</h1>
      </Route>
      <Route path={NOTIFICATIONS_ADD_ROUTE}>
        <AddEditNotifications/>
      </Route>
      <Route path={NOTIFICATIONS_EDIT_ROUTE}>
        <AddEditNotifications isEditing={true}/>
      </Route>
      <Route path={NOTIFICATIONS_ROUTE}>
        <Notifications/>
      </Route> 
      <Route path={NEWS_ADD_ROUTE}>
        <AddEditNovelty/>
      </Route>
      <Route path={NEWS_EDIT_ROUTE}>
        <AddEditNovelty isEditing={true}/>
      </Route>
      <Route path={NEWS_ROUTE}>
        <News/>
      </Route> 
      {/* <Route path={PASSWORD_RECOVERY}>
        <PasswordRecovery/>
      </Route> */}
      <Route path={STATISTICS_ROUTE}>
        <Statistics/>
      </Route>
      <Route path={TAGS_ADD_ROUTE}>
        <AddEditTag/>
      </Route>
      <Route path={TAGS_EDIT_ROUTE}>
        <AddEditTag isEditing={true}/>
      </Route>
      <Route path={TAGS_ROUTE}>
        <Tags/>
      </Route>
      <Route path={INDEX_ROUTE}>
        <Home/>
      </Route>
    </Switch>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./src/config/Routes.js